import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBase as MuiButtonBase, } from '@mui/material';
/**
 * `ButtonBase` is used to create custom button
 *  components, i.e. clickable cards or bars.
 *  By wrapping another component in the `ButtonBase`
 *  and passing an `onClick` function, you can create
 *  a customized button component.
 */
export function ButtonBase({ children, onClick, width = 'fit-content', }) {
    return (_jsx(MuiButtonBase, { onClick: onClick, sx: {
            width,
        }, children: children }));
}
